import { message, TreeSelect } from 'antd'
import React from 'react'
import Api from '../../api/Corporates/Accounts'
import withSpinning from '../../elements/HOC/withSpinning'
import { compose } from 'recompose'
import { unflatten } from '../../modules/Utils'

const Enhanced = compose(withSpinning)(TreeSelect)

class AccountsTreeSelect extends React.Component {
  state = {
    options: [],
  }
  api = new Api()

  async componentDidMount() {
    this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      let data = await this.api.list()
      data = data.filter((d) => d.company._id === this.props.center.company._id)
      const renamedData = data.map((d) => ({
        value: d._id,
        label: `${d.code} - ${d.name}`,
        _parent: d._parent,
      }))
      const mapped = unflatten(renamedData, 'value', '_parent')

      this.setState({
        options: mapped,
        fetching: false,
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({
        fetching: false,
      })
    }
  }

  render() {
    const { fetching, options } = this.state
    const tProps = {
      showCheckedStrategy: TreeSelect.SHOW_ALL,
      searchPlaceholder: 'Please select',
    }
    return (
      <Enhanced
        {...tProps}
        treeData={options}
        showSearch
        dropdownStyle={{ overflow: 'auto' }}
        allowClear
        multiple
        treeCheckable={true}
        fetching={fetching}
        {...this.props}
      />
    )
  }
}

export default AccountsTreeSelect
